import {PlusOutlined} from '@ant-design/icons';
import {Button,Form, Input} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useEffect} from 'react';

const WriteItem = ({value, onChange, icon, disabled, rules}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({value});
  }, [form, value]);

  const handleFinish = useCallback(async () => {
    const {value} = form.getFieldsValue(true);
    onChange(value);
    form.resetFields();
  }, [form, onChange]);

  return (
    <Form
      name="input-value"
      className="w-full"
      form={form}
      onFinish={handleFinish}
      scrollToFirstError
      layout={'vertical'}
    >
      <div className="flex w-full">
        <Form.Item
          noStyle
          name="value"
          rules={[
            {required: true},
            ...rules,
          ]}
        >
          <Input className="w-full" disabled={disabled}/>
        </Form.Item>
        <div className="w-2"/>
        <Button onClick={form.submit} icon={icon} disabled={disabled}/>
      </div>
    </Form>
  );
};

WriteItem.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.any,
  rules: PropTypes.array,
};

WriteItem.defaultProps = {
  value: '',
  onChange: () => undefined,
  icon: <PlusOutlined/>,
  rules: [],
};

export default memo(WriteItem);
